import { PropsWithChildren } from 'react'
import { Button, ButtonProps } from 'primereact/button'

import { Row } from '../common/pure/FlexContainer'
import { pi } from '../common/pure/PrimeIcon'
import ClassNameBuilder from '../../tools/ClassNameBuilder'
import TooltipWrapper from '../common/pure/TooltipWrapper'
import t from '../../tools/t'

interface TableActionContainerProps extends PropsWithChildren {
    disableAutoHide?: boolean
}
export const TableActionContainer = ({ children, disableAutoHide }: TableActionContainerProps) => {
    const classNames = new ClassNameBuilder()
        .add('table-actions')
        .addIf('auto-hide', disableAutoHide !== true)
    return (
        <Row wide arrangement="end" gap={0.25} className={classNames.toString()}>
            {children}
        </Row>
    )
}

interface TableButtonProps extends ButtonProps {
    tooltip?: string
    target?: string
}
export default function TableButton({ tooltip, target, ...props }: TableButtonProps) {
    return (
        <TooltipWrapper position="bottom" label={tooltip ?? ''} target={target} disabled={!tooltip}>
            <Button className="table-button" text {...props} />
        </TooltipWrapper>
    )
}

export const ArchiveButton = ({ target, ...props }: TableButtonProps) => (
    <TableButton
        tooltip={t('common_archive')}
        icon={pi('arrow-circle-down')}
        {...props}
        target={`archive_${target}`}
        severity="danger"
    />
)

export const RestoreButton = ({ target, ...props }: TableButtonProps) => (
    <TableButton
        tooltip={t('common_restore')}
        icon={pi('arrow-circle-up')}
        {...props}
        target={`restore_${target}`}
        severity="success"
    />
)

export const UnlinkButton = ({ target, ...props }: TableButtonProps) => (
    <TableButton
        tooltip={t('common_unassign')}
        icon={pi('times')}
        {...props}
        target={`unlink_${target}`}
        severity="danger"
    />
)

export const EditButton = ({ target, ...props }: TableButtonProps) => (
    <TableButton
        tooltip={t('common_edit')}
        icon={pi('pencil')}
        {...props}
        target={`edit_${target}`}
        severity="secondary"
    />
)

export const DetailsButton = ({ target, ...props }: TableButtonProps) => (
    <TableButton
        tooltip={t('common_details')}
        icon={pi('eye')}
        {...props}
        target={`details_${target}`}
        severity="secondary"
    />
)

export const DuplicateButton = ({ target, ...props }: TableButtonProps) => (
    <TableButton
        icon={pi('copy')}
        tooltip={t('common_duplicate')}
        {...props}
        target={`duplicate_${target}`}
        severity="secondary"
    />
)

export const DownloadButton = ({ target, ...props }: TableButtonProps) => (
    <TableButton
        icon={pi('download')}
        tooltip={t('common_download')}
        {...props}
        target={`download_${target}`}
        severity="secondary"
    />
)

export const ExportButton = ({ target, ...props }: TableButtonProps) => (
    <TableButton
        icon={pi('download')}
        tooltip={t('common_export')}
        {...props}
        target={`export_${target}`}
        severity="secondary"
    />
)
